// extracted by mini-css-extract-plugin
export default {"transcriptOptionsMenu":"FQ0yG3mHlayuns0f0O_Q"};